<div class="message-loader-spinner">
  <div #loader class="message-loader-spinner-text" >
    <span class="message-loader-spinner-text-top"></span>
    <span class="message-loader-spinner-text-bottom"></span> 
  </div>
</div>